import React, { useState, useEffect } from 'react'
import { Modal, Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import CustomTextArea from '../common/CustomTextArea';
import ImageInput from '../common/ImageInput';
import CustomInput from '../common/CustomInput';
import ImagesInput from '../common/ImagesInput';
import axios from 'axios';
import customAxios from '../../customAxios';
import { toast } from 'react-toastify';
const ViewBlog = ({ openModal, onCloseModal, id }) => {
    
   const [loading, setLoading] = useState(false)

   const [blogDetails, setBlogDetails] = useState({})

    useEffect(() => {
        getBlogDetails(id)
    }, [id])

    const { register, handleSubmit, setFieldValue, control, formState: { errors }, reset, setValue } = useForm();


    const getBlogDetails = async() => {

        setLoading(true)
        let blog = await customAxios.get(`admin/blog/${id}`);

        let datas = blog?.data?.data
        setBlogDetails(datas)

        let data = {
            title: datas?.title,
            description: datas?.description,
            image: datas?.image,
            videourl: datas?.videourl
        }


        // console.log({data})

        reset(data)
    }
    


    const clearclose = () => {
        setValue("name", "")
        onCloseModal()

    }

    return (

        <Modal isOpen={openModal} toggle={clearclose}>
            <ModalHeader toggle={clearclose}>
                <h5
                    className="modal-title f-w-600"
                    id="exampleModalLabel2"
                >
                    View Blog
                </h5>
            </ModalHeader>
            <ModalBody>
                <Form>
                    <CustomInput
                        fieldLabel='Title :'
                        control={control}
                        error={errors.title}
                        fieldName='title'
                        readOnly={true}
                    />
                    <CustomTextArea
                        fieldLabel='Description :'
                        control={control}
                        error={errors.description}
                        fieldName='description'
                        type="textarea"
                        readOnly={true}
                    />
                    <img 
                        src={blogDetails?.image}
                        style={{width: "300px", height: "auto", objectFit: "cover"}}
                    />
                    <CustomInput
                        fieldLabel='Video URL:'
                        control={control}
                        error={errors.videourl}
                        fieldName='videourl'
                        readOnly={true}
                    />
                </Form>
            </ModalBody>
        </Modal>

    )
}

export default ViewBlog
